import COMMON_LOGS_DATA_MODEL from "./commonLogsDataModel";

export const DESCRIPTION_FIELD = {
  label: COMMON_LOGS_DATA_MODEL.fullDescription.value,
  field: ["description"],
  props: {
    expand: true
  }
};

export const APPROVE_ACTION_LOG_FIELD = {
  label: COMMON_LOGS_DATA_MODEL.approveActionLog.value,
  field: COMMON_LOGS_DATA_MODEL.approveActionLog.key,
  lookapVal: COMMON_LOGS_DATA_MODEL.approveActionLog.key,
  props: {
    expand: false
  }
};